let endpoint = { url: "" };

export default endpoint;
